module.exports = __webpack_public_path__ + "img/faq-vital.d5580af8.png";